import React, { useEffect, useState } from "react";
import Popup from "../../../components/common/model/Popup";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../components/common/notification/Notification";
import checkedIcon from "../../../assets/check-mark.png";
import deleteIcon from "../../../assets/trash.png";
import closeIcon from "../../../assets/closeModel.png";
import useStyles from "../../../components/common/model/styles";
import { vehicleFields } from "./vehicleAllFields";
import FormField from "../../../components/common/FormField";
import Validation from "../../../utils/Validation";
import { useSelector } from "react-redux";
import {
  addVehicleAction,
  getVehicleById,
  getVehicleTypes,
  initialVehicleLocalState,
  resetNewVehicleLocal,
  setNewVehicleLocal,
  updateVehiclesAction,
} from "../../../store/reducers/vehicleSlice";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import ResetFormAlert from "./ResetFormAlert";

interface ManageVehiclesProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedVehicle: any; // Adjust type as per your requirement
  action?: any;
  setSelectedVehicle?: any;
}

const ManageVehicles: React.FC<ManageVehiclesProps> = (props) => {
  const classes = useStyles();
  const { open, onHide, title, selectedVehicle, action, setSelectedVehicle } =
    props;
  const fullWidth = true;
  const maxWidth: "sm" | "md" | "lg" | "xl" | false | undefined = "md";
  const [isActionCalled, setIsActionCalled] = useState(false);
  const { newVehicleLocal, vehicleTypes, singleVehicle } = useSelector(
    (state: any) => state.vehicle
  );

  const [vehicleDetails, setVehicleDetails] = useState<any>(
    initialVehicleLocalState
  );
  // Track previous vehicle type to detect user-initiated changes
 const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isClickReset, setIsClickReset] = useState(false);
  const [alerModeShow, setAlertModelShow] = useState(false);
  const dispatch = useDispatch();
  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    name: vehicleDetails?.name,
    vehicle_type: vehicleDetails?.vehicle_type,
  });

  // Extract vehicle types from the vehicleTypes array
  const vehicleTypeOptions = vehicleTypes.map((item: any) => ({
    id: item?.vehicle_type,
    label: item?.vehicle_type,
  }));

  // Update the subscription field to include vehicle type options
  const updatedFields = vehicleFields.map((field) => {
    if (field.id === "vehicle_type") {
      return { ...field, options: vehicleTypeOptions, type: "select" };
    }
    return field;
  });

  useEffect(() => {
    if (open && selectedVehicle && action === "edit") {
      dispatch(getVehicleById(selectedVehicle));
    }
  }, [open, selectedVehicle, action, dispatch]);

  useEffect(() => {
    if (action === "edit" && singleVehicle && selectedVehicle) {
      setVehicleDetails({ ...singleVehicle });
      // Initial load complete
      dispatch(setNewVehicleLocal({ ...singleVehicle }));
      setIsInitialLoad(true);
    } else {
      setVehicleDetails(initialVehicleLocalState);
      dispatch(setNewVehicleLocal(initialVehicleLocalState));
      setIsInitialLoad(false);
    }
  }, [action, singleVehicle]);

  const handleInputChange = (field: string, value: any) => {
    setVehicleDetails((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));
    // ✅ dispatch Redux action
    dispatch(
      setNewVehicleLocal({
        ...newVehicleLocal,
        [field]: value,
      })
    );
      // User manually changed vehicle type
  if (field === "vehicle_type") {
    setIsInitialLoad(false);
  }
    resetValidator(field);
  };

  useEffect(() => {
    if (open) {
      dispatch(getVehicleTypes());
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    }
  }, [dispatch, open]);

  const onBlurAction = (event: any) => {
    checkValidator(event.target.id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        const newPayload = {
          ...newVehicleLocal,
           capacity: newVehicleLocal?.capacity ==="" ? null : newVehicleLocal?.capacity,
            seats: newVehicleLocal?.seats ==="" ? null : newVehicleLocal?.seats,
            fuel_type: newVehicleLocal?.fuel_type ==="" ? null : newVehicleLocal?.fuel_type,
            efficiency: newVehicleLocal?.efficiency ==="" ? null : newVehicleLocal?.efficiency,
            cost_per_mile: newVehicleLocal?.cost_per_mile ==="" ? null : newVehicleLocal?.cost_per_mile,
        };
        if (action === "edit" && selectedVehicle) {
          dispatch(
            addVehicleAction({ id: selectedVehicle, ...newPayload })
          );
        } else {
          const { id, ...rest } = newVehicleLocal;
          dispatch(addVehicleAction({ ...rest }));
        }
        setIsActionCalled(false);
      } else {
        console.log("error in form", error);
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const hideHandler = () => {
    onHide();
    setSelectedVehicle(null);
    resetAllValidator();
    dispatch(setNewVehicleLocal(initialVehicleLocalState));
    setVehicleDetails(initialVehicleLocalState);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

   const handleClear = () => {
    if (newVehicleLocal?.id && action === "edit") {
      setVehicleDetails({ ...singleVehicle });
      setIsInitialLoad(true);
      dispatch(setNewVehicleLocal({ ...singleVehicle }));
    } else {
      setVehicleDetails(initialVehicleLocalState);
      setIsInitialLoad(false);
      dispatch(resetNewVehicleLocal());
    }
    setSelectedVehicle(null);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator();
    setIsClickReset(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

useEffect(() => {
  // Edit mode 
  if (action === "edit" && isInitialLoad) return;

  if (!vehicleDetails?.vehicle_type) return;

  const selectedType = vehicleTypes.find(
    (type: any) =>
      type?.vehicle_type?.trim().toLowerCase() ===
      vehicleDetails?.vehicle_type?.trim().toLowerCase()
  );

  if (!selectedType) return;

  const updatedData = {
    ...vehicleDetails,
    capacity: selectedType?.capacity ?? "",
    seats: selectedType?.seats ?? "",
    fuel_type: selectedType?.fuel_type ?? "",
    efficiency: selectedType?.efficiency ?? "",
    cost_per_mile: selectedType?.cost_per_mile ?? "",
  };

  setVehicleDetails(updatedData);
  dispatch(setNewVehicleLocal(updatedData));
}, [vehicleDetails?.vehicle_type, vehicleTypes]);

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              // style={{ right: 40 }}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
       
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText
            sx={{
              background: "#E5F4F1",
              padding: "10px 10px 10px 0px",
              border: "1px solid #CFCFCF",
              borderRadius: "5px",
            }}
          >
            <>
              <Notification />
              <Grid container spacing={1}>
                {updatedFields?.map((field, i) => {
                  let dynamicField = { ...field };
                  return (
                    <>
                      <FormField
                        key={field.id}
                        onPaste={(e: any) =>
                          field?.id === "name" || field?.id === "email"
                            ? ""
                            : e.preventDefault()
                        }
                        onKeyDown={(event: any) => {
                          if (
                            [8, 9, 37, 38, 39, 40, 18, 17].includes(
                              event.keyCode
                            ) ||
                            event.ctrlKey
                          )
                            return event;
                          if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(event.key)
                          ) {
                            event.preventDefault();
                          } else if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(
                              event.target.value + event.key
                            )
                          ) {
                            event.preventDefault();
                          }
                        }}
                        {...{
                          ...dynamicField,
                          value:
                            vehicleDetails && vehicleDetails[dynamicField.id] != null
                              ? vehicleDetails[dynamicField.id]
                              : "",
                          inSingleGridForm: true,
                          minDate:
                            field.id === "movingOnDate"
                              ? new Date()
                              : undefined,
                          // maxDate:
                          //   field.id === "followUpDate"
                          //     ? newLeadLocal?.movingOnDate &&
                          //       dayjs(newLeadLocal.movingOnDate)
                          //         .toDate()
                          //     : undefined,
                          variant: "outlined",

                          onChange: (e: any) =>
                            handleInputChange(field.id, e.target.value), // Call onChange prop
                          onBlur: onBlurAction,
                          isNonMarginTop: true,
                          GridFieldStyle: {
                            paddingLeft:
                              field.type === "daterangebothvalue" ||
                              field.type === "date"
                                ? "8px !important"
                                : "auto",
                          },
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx:
                              field.type === "text" || field.type === "password"
                                ? { height: "36px" }
                                : { padding: "10px 4px", height: "36px" },
                          },
                          error: error && error[field.id],
                        }}
                      />
                    </>
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageVehicles;
